import type { paths } from "@/api-schema";
import { useOccupationByUuidQuery } from "@/common/api/occupation/use-occupation-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { OccupationFormFields } from "../_components/occupation-form-fields";

interface UpdateViewParams {
  uuid: string;
}

export function UpdateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const params = useParams<UpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/occupation/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/occupation/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useOccupationByUuidQuery}
      notFoundProps={{
        title: t("masterdata:OccupationNotFound"),
        message: t("masterdata:OccupationDoesNotExist"),
        description: t("masterdata:PleaseCheckOccupationIdOrContactSupport"),
        backTo: "~/masterdata/occupation",
        backToLabel: t("masterdata:BackToOccupationOverview"),
      }}
    >
      <UpdateViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function UpdateViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:EditOccupation");
  const pageSubtitle = t("common:ReviewAndSaveChangesDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <OccupationFormFields uuid={uuid} />
    </CenteredLayout>
  );
}
